import {
SET_ERROR_UPLOAD_MESS,
SET_SHOW_ACCEPT_PAP_MODAL,
SET_SHOW_MODAL_RERENDER,
SET_SHOW_REJECT_PAP_MODAL,
SET_SUCCESS_UPLOAD_MESS,
SET_SHOW_MODAL_NO_RERENDER,
SET_SHOW_ACCOUNT_MODAL,
SET_SHOW_VIDEO_MODAL,
SET_SELECTED_VIDEO,
SET_SHOW_ACCEPT_DEVIS_MODAL,
SET_SHOW_REJECT_DEVIS_MODAL, SET_SHOW_OFFER_MODAL
} from "../actions/modal";

export const initialState = {
showModal: false,
showAccountModal: false,
showModalNoRerender: false,
showAcceptPapModal: false,
showRejectPapModal: false,
successUploadMess: "",
errorUploadMess: "",
showVideoModal: false,
showOfferModal: false,
selectedVideo: "",
idDocument: ""
};

const modal = (state = initialState, action = {}) => {
switch (action.type) {
// Cette action provoqué un rerender non voulu. Le bug a été corrigé mais ne venait pas de cette action en particulier
// A voir si cette action est bien utilisé et à voir pour la supprimer si elle ne l'est pas
case SET_SHOW_MODAL_RERENDER : {
return {
...state,
showModal: action.bool
};
}
// C'est l'une de ces deux actions qui est utilisé, à voir s'il ne faut pas en supprimer une
// Permet d'afficher la modal
case SET_SHOW_MODAL_NO_RERENDER : {
return {
...state,
showModalNoRerender: action.bool
};
}
// Affiche la modal d'acceptation du PAP
case SET_SHOW_ACCEPT_PAP_MODAL : {
return {
...state,
showAcceptPapModal: action.bool
};
}
// Affiche la modal de refus du PAP
case SET_SHOW_REJECT_PAP_MODAL : {
return {
...state,
showRejectPapModal: action.bool
};
}
// Affiche la modal de l'acceptation du devis
case SET_SHOW_ACCEPT_DEVIS_MODAL : {
return {
...state,
idDocument: action.id,
showAcceptDevisModal: action.bool
};
}
// Affiche la modal du refus du devis
case SET_SHOW_REJECT_DEVIS_MODAL : {
return {
...state,
idDocument: action.id,
showRejectDevisModal: action.bool
};
}
// Message de succès en cas d'upload de document par le user
case SET_SUCCESS_UPLOAD_MESS : {
return {
...state,
successUploadMess: action.msg
};
}
// Message d'erreur en cas d'upload de document par le user
case SET_ERROR_UPLOAD_MESS : {
return {
...state,
errorUploadMess: action.msg
};
}
// Modal d'information du compte
case SET_SHOW_ACCOUNT_MODAL : {
return {
...state,
showAccountModal: action.bool
};
}
// Affiche la modal pour les viéo
case SET_SHOW_VIDEO_MODAL : {
return {
...state,
showVideoModal: action.bool
};
}
// Permet de déterminer l'url de la vidéo sélectionné par le user et ainsi la charger via la balise <video>
case SET_SELECTED_VIDEO : {
return {
...state,
selectedVideo: action.url
};
}
// Affiche la modal des offres B2C
case SET_SHOW_OFFER_MODAL : {
return {
...state,
showOfferModal: action.bool
};
}
default:
return state;
}
};

export default modal;